var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['block', _vm.className],style:({
        'transform': !_vm.visible ? '' :
            _vm.step <= 4
            ? 'translate(' + _vm.cx + 'px, ' + _vm.cy + 'px)'
            : 'translate(' + _vm.left + 'px, ' + _vm.top + 'px) scale(' + _vm.lscale + ')',
        'will-change': _vm.step > 4 ? 'transform' : '',
        'display': _vm.visible ? '' : 'none'
    })},[(_vm.vl >= 1)?_c('div',_vm._l((_vm.bigSquares),function(item){return _c('div',{key:Math.random(item)},[(_vm.scale >= 3 + 0.1 * _vm.step)?_c('div',{style:({
          transform: 'translate(' + item.x * _vm.step + 'px, ' + item.y * _vm.step + 'px) rotate(' + item.rotate + 'deg)',
          width: _vm.step * 0.35 + 'px',
          height: _vm.step * 0.35 + 'px'
        })}):_vm._e()])}),0):_vm._e(),(_vm.vl >= 2)?_c('div',_vm._l((_vm.mediumSquares),function(item){return _c('div',{key:Math.random(item)},[(_vm.scale >= 9 + 0.15 * _vm.step)?_c('div',{style:({
          transform: 'translate(' + item.x * _vm.step + 'px, ' + item.y * _vm.step + 'px) rotate(' + item.rotate + 'deg)',
          width: _vm.step * 0.15 + 'px',
          height: _vm.step * 0.15 + 'px'
        })}):_vm._e()])}),0):_vm._e(),(_vm.vl >= 3)?_c('div',_vm._l((_vm.smallSquares),function(item){return _c('div',{key:Math.random(item)},[(_vm.scale >= 17 + 0.2 * _vm.step)?_c('div',{style:({
          transform: 'translate(' + item.x * _vm.step + 'px, ' + item.y * _vm.step + 'px) rotate(' + item.rotate + 'deg)',
          width: _vm.step * 0.05 + 'px',
          height: _vm.step * 0.05 + 'px'
        })}):_vm._e()])}),0):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }